/**
 * 广告展示控制器，
 * showIntervalTime 间隔时间，每间隔多长时间重新计算,单位是天
 * handler 回调
 * frequency 最大次数
 * delayTime 延时展示
 *
 * 比如：每小时 展示1次，每次延时15秒执行
 * */
import sdkTool from "If_AdTool/common/sdkTool";
function adRotator(obj){
   let {showIntervalTime=0,handler=null,apid="0",frequency=2,delayTime=0} = obj;
   let showNums = sdkTool.cookie('ifengWindowCookieName_'+ apid);
   if(Number(showNums) < frequency){       
        setTimeout(function(){
            sdkTool.cookie('ifengWindowCookieName_'+ apid, Number(showNums)+1 ,{expires:showIntervalTime});
            handler&&handler();
        },delayTime*1000)        
   }else{
       return;
   }
}
export default adRotator;

